import React, { Fragment } from 'react';
import { Home } from 'react-feather';
import { Link } from 'react-router-dom';
import './breadcrumb.css';
import DepoSecimi from './depo-secim/DepoSecimi';

const Breadcrumb = props => {
    const breadcrumb = props;
    return (
        <Fragment>
            <div className="container-fluid">
                <div className="page-header custom-page-header-breakcrumb">
                    <div className="row">
                        <div className="col">
                            <div className="page-header-left">
                                <div style={{ fontSize: "16px", fontWeight: "bold" }} >{breadcrumb.current}</div>
                                <ol className="breadcrumb pull-right">
                                    <li className="breadcrumb-item">
                                        <Link to="/index">
                                            <Home />
                                        </Link>
                                    </li>
                                    {breadcrumb.parent && <Link style={{ fontSize: "16px" }} to={breadcrumb.parentPath} className="breadcrumb-item">{breadcrumb.parent}</Link>}
                                    {/* {breadcrumb.sicForm&&<Link style={{fontSize:"16px"}} to={breadcrumb.parentPath} className="breadcrumb-item">{"SIC Formlar"}</Link>} */}
                                    {breadcrumb.current && <div id='breadcrumb-item-title' style={{ fontSize: "16px" }} to="" className="breadcrumb-item active">{breadcrumb.current}</div>}
                                </ol>
                            </div>
                        </div>
                        <div className="col">
                            {
                                props.depo &&
                                <DepoSecimi />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Breadcrumb
